import queryString from 'query-string';
import { hashHistory } from './hashHistory';

/**
 * Returns the value for the requested name in the query string
 * @param  {String} name Query String Key
 * @return {String}      Query String Value
 */
export function queryParam(name) {
  const query = queryString.parse(hashHistory.getCurrentLocation().search);
  return query[name];
}

/**
 * Query string wrapper
 * @param {Object} object
 * @return {String}
 */
export function toQueryString(object) {
  return queryString.stringify(object);
}
